
import { granjaApi } from "../../api";
import { useNotificacionesStore } from "../../store";
import Swal from "sweetalert2";





export const notificacionesXBodegas = async({ page, termino, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('id',  id);

        const { data } = await granjaApi.get(`/notificacion/xbodega`, { params });
        useNotificacionesStore.setState({ totalNotificacion: data.total });
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}




export const startAprobarTraslado = async(noti) => {
    try {
        await granjaApi.post('/notificacion/estado', noti);
        Swal.fire('Exitoso', `Notificación ${noti.estado}`, 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}

